export default "__VITE_ASSET__08b5d0b7__"